import { motion } from 'framer-motion';
import './Ticker.css';

export default function Ticker({ items = [], offset, className }) {
  const repeated = [...items, ...items, ...items, ...items, ...items, ...items, ...items, ...items, ...items, ...items];

  return (
    <div style={{ overflow: 'hidden', width: '100%' }}>
      <motion.div
        className={`ticker-line ${className || ''}`}
        style={{
          x: offset,
          display: 'flex',
          gap: '4rem',
          alignItems: 'center',
          width: 'max-content',
        }}
      >
        {repeated.map((item, i) => (
          <span key={i} style={{ flexShrink: 0 }}>{item}</span>
        ))}
      </motion.div>
    </div>
  );
}